export default __webpack_public_path__ + "static/cdtcloudblueprint-74d44b2cac35c90589727d2b601fcb79.gif";